export const REQUEST_PAGE_RESULTS = "REQUEST_PAGE_RESULTS";
export const PAGE_RESULTS_SUCCESS = "PAGE_RESULTS_SUCCESS";
export const PAGE_RESULTS_ERROR = "PAGE_RESULTS_ERROR";



// WEBPACK FOOTER //
// ./src/modules/pages/types.js